import React from 'react';

import Thumb from '../img/works/first-website.jpg';
import Home from '../img/work-details/first-website-home.jpg';
import Blog from '../img/work-details/first-website-blog.jpg';

const FirstWebsite = {
    id: 1, permalink: "first-website", thumb: Thumb, title: "First Website", category: "Web Template", categoryURL: "webtemplate", detailImg1: Home, detailImg2: Blog, previewTxt: "Preview", previewURL: "https://wasek23.github.io/first-website/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Simple Responsive Website Using HTML CSS &amp; JS.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Design With HTML5, CSS3 &amp; JavaScript</li>
            <li>Fully Responsive Web Template</li>
            <li>Responsive Slider</li>
            <li>Sidebar &amp; Footer Weights</li>
            <li>Blog Page</li>
        </ul>
    </>
};
export default FirstWebsite;